import { render, staticRenderFns } from "./SelectPostType.vue?vue&type=template&id=584eb84f&scoped=true"
import script from "./SelectPostType.vue?vue&type=script&lang=js"
export * from "./SelectPostType.vue?vue&type=script&lang=js"
import style0 from "./SelectPostType.vue?vue&type=style&index=0&id=584eb84f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584eb84f",
  null
  
)

export default component.exports